import { apiClient } from './client';

export interface ReportTimeParams {
  from?: string;
  to?: string;
  technicianId?: string;
  ticketId?: string;
  billable?: boolean;
  groupBy?: 'technician' | 'ticket';
}

export const reportsApi = {
  time: async (params: ReportTimeParams = {}) => {
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => v !== undefined && searchParams.set(k, String(v)));
    const res = await apiClient.get(`/reports/time?${searchParams}`);
    return res.data.data as { report: any[]; totals: { totalMinutes: number; billableMinutes: number; entries: number } };
  },

  tickets: async (params: { from?: string; to?: string } = {}) => {
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => v !== undefined && searchParams.set(k, String(v)));
    const res = await apiClient.get(`/reports/tickets?${searchParams}`);
    return res.data.data as { byStatus: any[]; byPriority: any[]; slaBreached: number; totalResolved: number };
  },

  billable: async (params: { from?: string; to?: string } = {}) => {
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => v !== undefined && searchParams.set(k, String(v)));
    const res = await apiClient.get(`/reports/billable?${searchParams}`);
    return res.data.data as { summary: any[]; totalBillableMinutes: number; totalBillableHours: number };
  },

  metrics: async (params: { from?: string; to?: string } = {}) => {
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => v !== undefined && searchParams.set(k, String(v)));
    const res = await apiClient.get(`/reports/metrics?${searchParams}`);
    return res.data.data as ReportMetrics;
  },
};

export interface ReportMetrics {
  counts: { created: number; resolved: number; open: number; unassigned: number };
  avgFirstResponseMinutes: number | null;
  avgResolutionMinutes: number | null;
  slaCompliancePct: number | null;
  slaBreached: number;
  csatAverage: number | null;
  csatResponses: number;
  backlogAge: { lt1d: number; d1to3: number; d3to7: number; gt7: number };
}
